export type {
  SignupModalCtaTrackerProps,
  SignupModalCtaType,
  SignupModalHeaderProps,
} from './signup-modal-header'
export { SignupModalHeader, useSignupModalCtaTracker } from './signup-modal-header'
